import { Code } from '@apollo/orbit';
import React from 'react';

import { format } from 'src/lib/format';

import { CopyOperationIdTooltip } from './CopyOperationIdTooltip';

export const OperationIdBadge = ({
  id,
  className,
}: {
  id: string;
  className?: string;
}) => {
  const shortId = format.shortQueryId(id);

  return (
    <Code variant="fullColor" className={className}>
      <CopyOperationIdTooltip operationId={id}>
        <span className="font-mono">{shortId}</span>
      </CopyOperationIdTooltip>
    </Code>
  );
};
